export const THEME_MODE_LIGHT = 'light'
export const THEME_MODE_DARK = 'dark'
